import styled from '@emotion/styled'
import { Orders } from '@open-tender/types'
import { OrderCard } from 'components'

const OrdersListView = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 1rem -1rem;
  opacity: 0;
  animation: slide-up 0.25s ease-in-out 0.25s forwards;
`

const OrdersListItem = styled.div`
  width: 36rem;
  max-width: 100%;
  padding: 0 1rem;
  margin: 0 0 2rem;
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    width: 100%;
  }
`

const OrdersList = ({ orders }: { orders: Orders }) => {
  return (
    <OrdersListView>
      {orders.map((order) => {
        return (
          <OrdersListItem key={order.order_id}>
            <OrderCard order={order} />
          </OrdersListItem>
        )
      })}
    </OrdersListView>
  )
}

export default OrdersList
